import React, { type FC } from "react";
import {
  Glyph,
  SystemModalHeader,
  SystemModalIcon,
} from "@edreamsodigeo/prisma-design-system";

const UserVerificationModalHeader: FC = () => {
  return (
    <SystemModalHeader type="informative">
      <SystemModalIcon>
        <Glyph
          category="Alerts"
          name="InfoCircle"
          color="blue.50"
          size="medium"
        />
      </SystemModalIcon>
    </SystemModalHeader>
  );
};

export default UserVerificationModalHeader;
